// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","selected":"Tag_selected__8lJ8b"};